module.exports = __webpack_public_path__ + "static/media/box.788cfe1b.png";